var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPositionBl = function SvgPositionBl(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.05882,
    height: 7.05882,
    rx: 2,
    fill: "#D8D8D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 8.47059,
    width: 7.05882,
    height: 7.05882,
    rx: 2,
    fill: "#D8D8D8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 16.9412,
    width: 7.05882,
    height: 7.05882,
    rx: 2,
    fill: "#017AFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9412,
    width: 7.05882,
    height: 7.05882,
    rx: 2,
    fill: "#D8D8D8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9412,
    y: 8.47059,
    width: 7.05882,
    height: 7.05882,
    rx: 2,
    fill: "#D8D8D8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9412,
    y: 16.9412,
    width: 7.05882,
    height: 7.05882,
    rx: 2,
    fill: "#D8D8D8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.47058,
    width: 7.05882,
    height: 7.05882,
    rx: 2,
    fill: "#D8D8D8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.47058,
    y: 8.47059,
    width: 7.05882,
    height: 7.05882,
    rx: 2,
    fill: "#D8D8D8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.47058,
    y: 16.9412,
    width: 7.05882,
    height: 7.05882,
    rx: 2,
    fill: "#D8D8D8"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPositionBl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/position-bl.bf6465b1.svg";
export { ForwardRef as ReactComponent };